<a
  class="nav-link"
  [ngClass]="{ 'list-group-item list-group-item-action': listGroupAction }"
  [attr.data-e2e]="label"
  [ngClass]="{ active: isActive }"
  (click)="navigate($event)"
>
  @if (icon) {
  <fa-icon [class.mr-2]="!iconOnly" [icon]="icon" size="1x"></fa-icon>
  } @if (!iconOnly) {
  <span>
    {{ name }}
  </span>
  }
</a>
